import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  inject,
  OnInit,
} from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, NgForOf } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthService } from 'src/app/services/auth.service';
import { FilePathPipe } from 'src/app/shared/pipes/file-path.pipe';
import { USER_ROLES } from 'src/app/config/user-roles';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    FilePathPipe,
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  authService = inject(AuthService);
  router = inject(Router);

  isSchool = false;

  get isInstructorRoute(): boolean {
    const url = this.router.url;
    const isInstructor = this.authService.userSig()?.role === USER_ROLES.INSTRUCTOR;
    return url.startsWith('/instructor') || (isInstructor && url.startsWith('/profile'));
  }

  ngOnInit(): void {
    const userRole = this.authService.userSig()?.role;

    this.isSchool = userRole === USER_ROLES.SCHOOL_OWNER;
  }


  onLogout() {
    this.authService.logout();
    this.router.navigateByUrl('/auth/login');
  }

}
